import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import { getEnv } from 'utils';

const config = {
  lng: getEnv('REACT_APP_LANGUAGE'),
  fallbackLng: getEnv('REACT_APP_LANGUAGE'),
  ns: [
    'common',
    'validations',
    'users',
    'companies',
    'alarm',
    'layout',
    'breadcrumbs',
    'error',
    'filter',
    'bulletin',
    'changelog',
    'comparison',
    'content',
    'kiosk',
    'notifications',
    'onboarding',
    'profile',
    'resource',
    'resourceCategory',
    'search',
    'settings',
    'statistics',
    'subject',
    'support',
    'tag',
    'vipResources',
    'tinyUrl',
    'academy',
    'dashboard',
    'brandBaan',
    'brandBuilder',
    'industriesBuilder',
    'excel',
    'ecommerce',
  ],
  interpolation: {
    escapeValue: false,
  },
  debug: getEnv('REACT_APP_ENVIRONMENT') === 'development',
};

export function initTranslation() {
  return i18n.use(HttpApi).use(initReactI18next).init(config);
}

if (!i18n.isInitialized) {
  initTranslation();
}

export default i18n;
